(function () {
  // Skip in Shopify editor — animations interfere with live section editing
  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  // Respect user preference — exit cleanly, CSS fallback handles safety
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Enable CSS motion states (hidden initial states activate via this class)
  document.documentElement.classList.add('gac-motion-ready');

  // Reveal elements as they enter the viewport
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -32px 0px'
    }
  );

  document.querySelectorAll('.gac-reveal').forEach(function (el) {
    observer.observe(el);
  });
})();

// Header nav: open mega-menu / dropdown panels on hover at desktop breakpoint
;(function () {
  var DESKTOP_MQ  = window.matchMedia('(min-width: 990px)');
  var OPEN_DELAY  = 120; // ms — hover-intent: prevents accidental trigger on cursor pass
  var CLOSE_DELAY = 150; // ms — grace period so moving into the panel doesn't dismiss it

  function openDetails(details) {
    details.setAttribute('open', '');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  function closeDetails(details) {
    details.removeAttribute('open');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function closeOthers(current) {
    document.querySelectorAll('header-menu details[open]').forEach(function (d) {
      if (d !== current) closeDetails(d);
    });
  }

  function bindHover(menu) {
    if (menu._gacHoverBound) return;
    menu._gacHoverBound = true;

    var details = menu.querySelector('details');
    if (!details) return;

    var openTimer  = null;
    var closeTimer = null;

    menu.addEventListener('mouseenter', function () {
      if (!DESKTOP_MQ.matches) return;
      clearTimeout(closeTimer);
      closeOthers(details);
      if (!details.hasAttribute('open')) {
        openTimer = setTimeout(function () { openDetails(details); }, OPEN_DELAY);
      }
    });

    menu.addEventListener('mouseleave', function () {
      if (!DESKTOP_MQ.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { closeDetails(details); }, CLOSE_DELAY);
    });
  }

  function init() {
    document.querySelectorAll('header-menu').forEach(bindHover);
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();

